import { PraticaStats } from '../pratica/models/pratica-stats';
import { Slice } from './models/slice';

export const OUTCOME_SLICES: Slice[] = [
  {
    sectionPath: PraticaStats.BILANCIO,
    disabled: false,
    tooltipPosition: 'above',
    tooltip: 'Analisi bilancio',
    ariaLabel: 'Analisi bilancio',
    icon: 'financial-analysis',
  },
  {
    sectionPath: PraticaStats.GARANZIE,
    disabled: false,
    tooltipPosition: 'after',
    tooltip: 'Analisi garanzie',
    ariaLabel: 'Analisi garanzie',
    icon: 'guarantees',
  },
  {
    sectionPath: PraticaStats.KYC,
    disabled: false,
    tooltipPosition: 'above',
    tooltip: 'KYC',
    ariaLabel: 'KYC',
    icon: 'kyc',
  },
  {
    sectionPath: PraticaStats.QUESTIONARIO_QUALITATIVO,
    disabled: false,
    tooltipPosition: 'above',
    tooltip: 'Questionario qualitativo',
    ariaLabel: 'Questionario qualitativo',
    icon: 'quality-survey',
  },

  {
    sectionPath: PraticaStats.CREDIT_SCORE_CRIF,
    disabled: false,
    tooltipPosition: 'after',
    tooltip: 'Credit Score CRIF',
    ariaLabel: 'Credit Score CRIF',
    icon: 'crif-credit-score',
  },
  {
    sectionPath: PraticaStats.ANDAMENTALE,
    disabled: false,
    tooltipPosition: 'above',
    tooltip: 'Analisi andamentale',
    ariaLabel: 'Analisi andamentale',
    icon: 'outlook-analysis',
  },
];
